import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import church from '../../assets/images/home/church.png';
import ActionButton from 'components/ui/buttons/action-button';
import Animated from 'components/generals/AnimatedComponent';
import { Link } from 'react-router-dom';

export default function Home__section__2() {
    return (
        <main className="nv__section nv__section--no-margin   nv__hp__section__2">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInUp animate__delay-1s'}>
                    <h1>¿Por qué considerar las raíces?</h1>
                </Animated>

                <Animated animation={'animate__fadeInUp animate__delay-2s'}>
                    <p>
                        El cultivo de raíces y tubérculos en México ofrece costos de producción
                        razonables, lo que puede traducirse en márgenes de beneficio atractivos para
                        aquellos interesados en participar en esta industria.
                    </p>
                </Animated>

                <Animated animation={'animate__fadeInUp animate__delay-3s'}>
                    <p>
                        Con nosotros, tendrás acceso a oportunidades únicas en la industria en
                        México, permitiéndote diversificar tu cartera y maximizar tus ganancias
                        potenciales.
                    </p>
                </Animated>

                <Animated animation={'animate__fadeInUp animate__delay-4s'}>
                    <Link to="https://wa.me/5215531151431" target="_blank">
                        <ActionButton text="¡Conócelas aquí!" type="rounded" color="white" />
                    </Link>
                </Animated>
            </section>
        </main>
    );
}
